import React, { Component } from "react";
import axios from "axios";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeSeriesScale,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { withRouter } from "react-router-dom";
import 'chartjs-adapter-date-fns';

ChartJS.register(
  CategoryScale,
  LinearScale,
  TimeSeriesScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

class App extends Component {
  constructor(props) {
    super(props);
    const { location } = this.props;
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      isLoaded: false,
      value: location.pathname !== "/" ? location.pathname.slice(1) : ""
    };
    this.chartData = this.getEmptyChartData();
    this.options = {
      scales: {
        x: {
            type: 'timeseries',
        }
      },
    };
  }
  getEmptyChartData() {
    return {
      datasets: [
        {
          data: [],
          borderColor: "rgb(9,158,255)",
          backgroundColor: "rgba(0,0,0,0)",
          borderWidth: 1,
          pointRadius: [],
          pointBackgroundColor: []
        }
      ],
      labels: []
    };
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.history.push(this.state.value);
    this.getChart(this.state.value);
  }

  async getChart(symbol) {
    // Clean everything up
    this.setState({
      isLoaded: false
    });
    this.chartData = this.getEmptyChartData();
    const token = "pk_a51c02d749f440b18cc7f5c3143b9440";
    const base_url = "https://cloud.iexapis.com/stable/stock/";

    const earnings = await axios.get(
      "https://www.alphavantage.co/query?function=EARNINGS&symbol="+symbol+"&apikey=AD0PYNKKI93K9QSC"
    );
    const historical_data = await axios.get(
      base_url + symbol + "/chart/2y?token=" + token
    );
    this.chartData.datasets[0]["label"] = symbol;    
    this.insertHistoricalData(historical_data.data, this.formatEarningsDates(earnings.data));
  }

  componentDidMount() {
    if (this.state.value) {
      this.getChart(this.state.value);
    }
  }

  formatEarningsDates(earnings_dates) {
    var data = [];
    for (const date of earnings_dates['quarterlyEarnings']) {
      data.push(date.reportedDate);
    }
    return data;
  }

  insertHistoricalData(historical_data, earnings_dates) {
    for (const data_point of historical_data) {
      this.chartData.datasets[0].data.push(data_point.close);
      if (earnings_dates.includes(data_point.date)) {
        this.chartData.datasets[0].pointRadius.push(6);
        this.chartData.datasets[0].pointBackgroundColor.push("#004F83");
      } else {
        this.chartData.datasets[0].pointBackgroundColor.push("#ffffff");
        this.chartData.datasets[0].pointRadius.push(2);
      }
      this.chartData.labels.push(new Date(data_point.date));
    }

    this.setState({
      isLoaded: true
    });
  }

  render() {
    return (
      <div className="App">
        <form onSubmit={this.handleSubmit}>
          <input
            type="text"
            name="symbol"
            placeholder="MU"
            value={this.state.value}
            onChange={this.handleChange}
            className="ticker-input"
          />
        </form>
        {this.state.isLoaded && (
          <Line data={this.chartData} options={this.options}/>
        )}
      </div>
    );
  }
}

export default withRouter(App);
